// extracted by mini-css-extract-plugin
export default {"box":"list-module_box-OYM_T"};